// extracted by mini-css-extract-plugin
export default {"container":"Partnership_container__8AtGa","inner":"Partnership_inner__HlBRy"};